/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/AppointmentActions/DeleteAppointment/Content/ConfirmationDialog/Content/DeleteAction/Content",
  isSubmitting
  
}) {
let appointmentActionsIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'appointment_actions',
})
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  isSubmitting
  
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="primary"
 onClick={onClick}
 data="appointment_actions"
 disabled={appointmentActionsIsSubmittingData}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Delete"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}